<template>
    <div>
        <toast-alert v-if="isSending" :isLoading="isLoading" :text="`ติดตามที่ line @FINNOMENA`"></toast-alert>
        
        <toast-confirmation v-if="noFriendship">
            <h3 slot="header">ไม่สามารถลงทุนในกองนี้ได้</h3>
            <div slot="body" class="confirm-body">เป็นเพื่อนกับ @FINNOMENA เพื่อลงทุนในกองนี้</div>
            <a @click="addFriend" slot="confirm-yes" class="left pointer">เพิ่มเพื่อน</a>
            <a @click="cancelFriendship" slot="confirm-no" class="right pointer">ยกเลิิก</a>
        </toast-confirmation>
    </div>
</template>

<script>
import ToastAlert from "../../../components/miniapp/global/ToastAlert.vue";
import ToastConfirmation from "../../../components/miniapp/global/ToastConfirmation.vue";
export default {
    components: {
      ToastAlert,
      ToastConfirmation
    },
    props: {
        noFriendship: {
            type: Boolean,
            required: true
        },
        isSending: {
            type: Boolean,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        cancelFriendship() {
            this.$emit("update:no-friendship", false)
        },
        addFriend() {
            this.$emit("update:no-friendship", false)
            this.$emit("update:is-sending", false)
            this.$emit("update:is-loading", false)
    
            try {
              this.$liff.openWindow({
                url: process.env.VUE_APP_OA_URL_NEW_SCHEME,
                external: false
              });
            } catch (err) {
              window.open(process.env.VUE_APP_OA_URL_NEW_SCHEME);
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.pointer {
    cursor: pointer;
}

.right {
    color: #d1d1d1;
}
</style>